import { render, staticRenderFns } from "./ModalAddTemplate.vue?vue&type=template&id=36c83a6e&lang=pug&"
import script from "./ModalAddTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalAddTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddTemplate.vue?vue&type=style&index=0&id=36c83a6e&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports